module.exports = __webpack_public_path__ + "static/media/pp.7ee7300b.svg";